var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgYoutube = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "-35.2 -41.3 192.4 165.3"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M37 76V6l61 35zm136-92c-2-10-10-18-20-20-19-5-92-5-92-5s-73 0-92 5c-10 2-18 10-20 20-5 19-5 57-5 57s0 39 5 57c2 10 10 18 20 21 19 5 92 5 92 5s73 0 92-5c10-3 18-11 20-21 5-18 5-57 5-57s0-38-5-57"
})));
export default SvgYoutube;